import { api } from '../api/client';

export type PreferenceView = {
  learnerId: string;
  /** Best first. Empty until the learner has been asked. */
  ranking: string[];
  favourite: string | null;
  assessedAtEpochMs: number | null;
  /** Everything a learner can be offered, as the server knows it. */
  choices: string[];
};

export async function fetchPreference(learnerId: string | null): Promise<PreferenceView> {
  return api<PreferenceView>(
    learnerId ? `/preferences?learnerId=${encodeURIComponent(learnerId)}` : '/preferences',
    { token: true },
  );
}

export async function savePreference(
  learnerId: string,
  ranking: string[],
): Promise<PreferenceView> {
  return api<PreferenceView>('/preferences', {
    method: 'POST',
    token: true,
    body: { learnerId, ranking },
  });
}
